<template>
    <div class="elle-page-news">
        <section class="elle-page-news-headline padd-v">
            <div class="container">
                <UiHeadline
                    :settings="{
                        label: data?.label,
                        headline: data?.headline
                    }"
                >
                    <template #additional>
                        <FormsNewsFilter @on-change-filter="id => onChangeFilter(id)" />
                    </template>
                </UiHeadline>
                <LoopsPosts v-show="!loading && !!posts.length" :posts="posts" @on-end-scroll="onScrollEnd" />
                <LoopsPostsBlank v-show="loading && posts.length == 0" />
            </div>
        </section>

        <CommonBuilder :data="data?.elements" />
    </div>
</template>

<script setup lang="ts">
defineProps({
    data: {
        type: Object,
        default: () => ({})
    }
});

const { $ScrollTrigger: ScrollTriger } = useNuxtApp();

const offset = ref(0);
const limit = ref(16);
const categories = ref<any>(null);
const posts = ref<any>([]);
const postsCount = ref(0);
const loading = ref(true);
const siteId = useSiteId();

const getPostsData = async (add: boolean) => {
    loading.value = true;

    posts.value = [];
    postsCount.value = 0;

    try {
        const data = await GqlPosts({
            siteId: siteId,
            limit: limit.value,
            offset: offset.value,
            category: categories.value
        });

        if (data.posts?.length) {
            if (!add) {
                posts.value = data.posts;
            } else {
                posts.value = { ...posts.value, ...data.posts };
            }

            postsCount.value = data.postsCount;
        }
    } catch (error) {
        console.log(error);
    }

    ScrollTriger.refresh(true);
    loading.value = false;
};

const onScrollEnd = () => {
    if (postsCount.value > offset.value + limit.value) {
        offset.value += limit.value;
        getPostsData(true);
    }
};

const onChangeFilter = (id: number) => {
    categories.value = id !== -1 ? [id] : null;
    getPostsData(false);
};

onMounted(() => {
    getPostsData(false);
});
</script>
